import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/database';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyADbBWedZd3joEE2xuIpYzAgml1-TLWH-o',
  authDomain: 'finance-base.firebaseapp.com',
  databaseURL: 'https://finance-base-default-rtdb.firebaseio.com',
  projectId: 'finance-base',
  storageBucket: 'finance-base.appspot.com',
  messagingSenderId: '31472824578',
  appId: '1:31472824578:web:f05617ba99404c95d7d21b',
  measurementId: 'G-N20RDS60PH'
};

!firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.database();
export const Functions = firebase.functions();
export const Database = firebase.database();
export const auth = firebase.auth();
